import type { BenefitTag } from "@yutai/shared"
import styles from "./TagBadge.module.css"

const LABELS: Record<BenefitTag, string> = {
  rice: "米",
  coffee: "コーヒー",
  water: "水",
  gourmetCard: "グルメカード",
  crypto: "暗号資産",
  golf: "ゴルフ",
  beauty: "美容",
  amusement: "アミューズメント",
  education: "教育・学習",
  ceremonial: "冠婚葬祭",
}

interface Props {
  tag: BenefitTag
}

export function TagBadge({ tag }: Props) {
  return <span className={styles.badge}>{LABELS[tag]}</span>
}
